import { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getProductListing } from '@services/ProductAPI/client';
import { fetchGuestToken } from '@services/api/apiService';
import { getFooter, getHeader, getLocales } from '@services/contentful/api';
import contentfulClient, {
  contentfulPreviewClient
} from '@services/contentful/client';
import ProductListing from '@components/ProductListing';
import HeadingWithSubText from '@components/headingWithSubText';
import Layout from '@components/layout';
import PLPLoader from '@components/loader/landingPage';
import PageHead from '@components/pageHead';
import { paramsToObject } from '@utils/index';
import { PageContentTypes } from '@constants/index';

export default function ProductList({
  // productListingData,
  requestBody,
  params,
  pageData,
  headerData,
  footerData,
  locales,
  seoMetadata
}) {
  //   console.log(productListingData, 'pld');
  let helpUsImproveFields;
  const [productListingData, setProductListingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  useEffect(() => {
    const fetchData = async () => {
      // const token = await fetchGuestToken();
      const searchParams = new URLSearchParams(window.location.search);
      const obj = paramsToObject(searchParams.entries());
      const data = await getProductListing({ ...requestBody, ...obj });
      if (!data?.response?.['@odata.count']) {
        router.push('/404');
      }
      setProductListingData(data);
      setLoading(false);
    };
    setLoading(true);
    fetchData();
  }, [requestBody]);

  // if (!productListingData) return <PLPLoader></PLPLoader>;
  return (
    <>
      <PageHead {...seoMetadata} />
      <Head>
        <script id='schemaorg_itemlist' type='application/ld+json'>
          {`{
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name": "${seoMetadata?.pageTitle}",
            "description": "${seoMetadata?.description}",
            "url": "${seoMetadata?.canonicalUrl}"
          }`}
        </script>
      </Head>
      {pageData?.sections?.length > 0 &&
        pageData?.sections.forEach(section => {
          const sectionType = section?.sys?.contentType?.sys?.id;
          const internalTitle = section?.fields?.internalTitle;
          if (sectionType === 'headingWithSubText') {
            if (internalTitle === 'Engines - Help us Improve this Site')
              helpUsImproveFields = section?.fields;
          }
        })}
      <Layout headerData={headerData} footerData={footerData} locales={locales}>
        {loading ? (
          <PLPLoader></PLPLoader>
        ) : productListingData ? (
          <ProductListing
            productListingData={productListingData}
            requestBody={requestBody}
            params={params}
          />
        ) : (
          <div>No products found</div>
        )}

        {helpUsImproveFields && (
          <HeadingWithSubText fields={helpUsImproveFields} />
        )}
      </Layout>
    </>
  );
}

export async function getServerSideProps(context) {
  const {
    params: { slug },
    locale,
    preview
  } = context;
  const client = preview ? contentfulPreviewClient : contentfulClient;

  const query1 = await client.getEntries({
    content_type: PageContentTypes.LandingPage,
    'fields.slug': `products/${slug}`,
    'metadata.tags.sys.id[in]': 'homeEnergy',
    include: 7
  });
  const query2 = getHeader({ preview });
  const query3 = getFooter({ preview });
  const locales = await getLocales(preview);
  const results = await Promise.all([query1, query2, query3]);

  const res = results[0];
  const headerData = results[1];
  const footerData = results[2];

  //PLP API CALL --> Start
  const requestBody = {
    ProductLocalCategory: slug.replace(/\+/g, ' '),
    loadedProductsCount: 12
  };

  // PLP API --> end

  return {
    props: {
      ...headerData,
      ...footerData,
      // productListingData,
      requestBody,
      params: { slug },
      seoMetadata: res?.items?.[0]?.fields?.seoMetadata?.fields ?? null,
      pageData: results[0]?.items?.[0]?.fields ?? null,
      locales
    }
  };
}
